import { Component, inject } from '@angular/core';
import { TokenService } from '@libs/shared-services';
import { TranslatePipe } from '@ngx-translate/core';
import { SiteSetupComponentService, StepNumberEnum } from '../site-setup/site-setup.component.service';
import { SiteSetupNavbarComponent } from '../site-setup/components/site-setup-navbar/site-setup-navbar.component';

@Component({
  selector: 'lib-it-provider-contacted',
  imports: [SiteSetupNavbarComponent, TranslatePipe],
  templateUrl: './it-provider-contacted.component.html',
  styleUrl: './it-provider-contacted.component.scss',
})
export class ItProviderContactedComponent {
  private readonly service = inject(SiteSetupComponentService);
  private readonly tokenService = inject(TokenService);

  protected readonly vm = this.service.viewModel;
  protected readonly StepNumberEnum = StepNumberEnum;

  protected signOut(): void {
    this.tokenService.logout();
  }
}
